










import { Vue, Component } from 'vue-property-decorator';
import EnvioInformacion from '@/pantallas/EnvioInformacion/EnvioInformacion.vue';

@Component({
  components: { EnvioInformacion },
})
export default class EnvioInformacionPantalla extends Vue {}
